import React, { forwardRef, useState, useRef } from 'react';

import ReactGeetest from '@cvte/react-geetest';
import '@cvte/react-geetest/dist/index.css';

import './index.module.less';

import FridayService from '@services/friday';
import userStore from '@stores/user';
import Http from '@helpers/Http';
import { Api } from '@apis/client';
import {
  systemAppCode,
  roleType,
  systemAppType,
  conditionList,
  templateSmsType
} from '../constant';
import Filter from '@helpers/Filter';

import NavBar from '@components/NavBar';
import Toast from '@widgets/Toast';
import Alert from '@widgets/Alert';
import Input from './Input';
import VerifyHelp from './VerifyHelp';
import Error from './Error';
import Success from './Success';

interface IProps {
  onBack?: () => void;
}

const Verify = (props: IProps, ref: any) => {
  const [verifyCode, setVerifyCode] = useState('');
  const [content, setContent] = useState('获取验证码');
  const [disable, setDisable] = useState(true);
  const [checkResult, setCheckResult] = useState<{
    checkType: string;
    code?: string[];
  } | null>(null);
  const urlParams = useRef<{ appCode?: string; roleType?: string | number }>(
    Filter.urlParams(window.location.search),
  );

  const code = urlParams.current.appCode || systemAppCode.cubeApp;
  const intervalTimer = useRef(null);
  const geetsetRef = useRef(null);
  const captchaObj = useRef(null);

  const [showHelpModal, controlDisplayHelpModal] = useState(false);

  const getDynamics = async (key: any, captcha: any) => {
    const param = {
      phone: userStore.userInfo.phone,
      key,
      captcha,
      templateCode: code ===  systemAppCode.campusMiniprogram ? templateSmsType.yunban : templateSmsType.cube, //魔方注销模版code
    };
    setContent('加载中...');
    setDisable(true);
    const res = await Http.post(Api.PostSendPhoneSms, param);
    if (res.statusCode === 200) {
      Toast.show({
        title: '获取验证码成功',
        type: 'strip',
      });
      startCountDown();
    } else {
      setContent('获取验证码');
      setDisable(false);
      Toast.show({
        title: '验证码获取失败，请稍后重试',
        type: 'strip',
      });
    }
  };

  const cancelGeetest = () => {
    setContent('获取验证码');
    setDisable(false);
  };

  const clearVerifyStatus = () => {
    setVerifyCode('');
    clearInterval(intervalTimer.current);
    setContent('获取验证码');
    setDisable(false);
  };

  const startCountDown = () => {
    let time = 60;
    let content = `${time}s后重试`;
    intervalTimer.current = setInterval(() => {
      setContent(content);
      time -= 1;
      content = `${time}s后重试`;

      if (time < 0) {
        clearInterval(intervalTimer.current);
        setContent('获取验证码');
        setDisable(false);
      }
    }, 1000);
  };

  const handleInputChange = (e: any) => {
    let val = e.target.value;
    val = val.replace(/[^\d]/g, '');
    if (val.length > 6) {
      return;
    }
    setVerifyCode(val);
  };

  const handleComposition = (val: any) => {
    console.log('val handleComposition');
  };

  const handleGeetestSuccess = (e: any) => {
    try {
      getDynamics(e.key, e.captcha);
    } catch (err) {
      console.log(err);
    }
  };

  const handleGeetestError = (error: any) => {
    console.log('handleGeetestError', error);
    if (error.error_code === 'error_109') {
      Toast.show({
        type: 'strip',
        title: '网络异常，请稍后重试',
      });
    }
    cancelGeetest();
    geetsetRef.current.reload();
  };

  const handleGeetestClose = (e: any) => {
    geetsetRef.current.reload();
    cancelGeetest();
  };

  const handleGeetestFail = (err: any) => {
    console.log('handleGeetestFail', err);
    Toast.show({
      title: '验证码发送失败，请重试',
      type: 'strip',
    });
    cancelGeetest();
    geetsetRef.current.reload();
  };

  const startVerify = () => {
    if (captchaObj.current) {
      captchaObj.current.verify();
    } else {
      geetsetRef.current.reload();
      Toast.show({
        type: 'strip',
        title: '获取验证码失败，请稍后重试',
      });
    }
  };

  const handleVerify = () => {
    if (disable) {
      return;
    }
    setContent('加载中...');
    setDisable(true);
    startVerify && startVerify();
  };

  const handleLogout = async () => {
    FridayService.addEvent(
      'logout_account_security_verification_confirm_logout_click',
    );
    const param = {
      phone: userStore.userInfo.phone,
      dynamicCode: verifyCode,
    };
    if (verifyCode.length !== 6) {
      return;
    }
    //1.校验验证码是否正确
    const result = await Http.post(Api.PostSendPhoneValid, param).catch(err => {
      if (err.statusCode === 34003) {
        return Alert.show({
          title: '验证码已过期',
        });
      }
      if (err.statusCode === 34002) {
        return Alert.show({
          title: '尝试次数过多，请稍后再试',
        });
      }
    });

    if (!result) {
      return;
    }

    const { data: valideData, statusCode } = result;
    if (statusCode === 200 && !valideData) {
      return Alert.show({
        title: '验证码不正确',
      });
    }

    //2.如果是小程序，使用小程序的判断注销接口
    if (code === systemAppCode.campusMiniprogram) {
      const { data: checkData } = await Http.post(
        Api.PostLoginAccountMiniCancelCheck,
        {
          userUid: userStore.userInfo.uid,
          appCode: code,
          userType: roleType[urlParams.current.roleType],
        },
      );
      if (checkData?.length) {
        setCheckResult({
          checkType: 'error',
          code: checkData,
        });
        return;
      }
    }

    if (code === systemAppCode.cubeApp) {
      //3.判断是否满足电子学生证管理条件
      const { data: manageDevices } = await Http.post(Api.GetAdminDevices, {
        userUid: userStore.userInfo.uid,
      });
      if (manageDevices?.length) {
        const resCode = [];
        if (manageDevices.length) {
          resCode.push(conditionList[0].title);
        }
        if (resCode.length) {
          setCheckResult({
            checkType: 'error',
            code: resCode,
          });
          return;
        }
      }
    }
    //4.满足条件，去注销帐号
    toLogout();
  };

  const toLogout = async () => {
    const condition: any = {
      userUid: userStore.userInfo.uid,
    };
    if (code === systemAppCode.campusMiniprogram) {
      condition.appCode = code;
      condition.appType = systemAppType.miniprogram;
      if (urlParams.current?.roleType) {
        condition.userType = roleType[urlParams.current.roleType];
      }
    }

    if (code === systemAppCode.cubeApp) {
      condition.appCode = code;
      condition.appType = systemAppType.app;
      condition.userType = roleType.parents;
    }
    await Http.post(Api.PostLoginAccountCancel, condition);
    setCheckResult({
      checkType: 'success',
    });
  };

  const handleGeetestReady = (obj: any) => {
    captchaObj.current = obj;
    setDisable(false);
  };

  const clickBack = () => {
    props.onBack && props.onBack();
  };

  const renderPhone = userStore.userInfo.phone
    ? userStore.userInfo.phone
        .toString()
        .replace(/(\d{3})\d*(\d{4})/, `$1****$2`)
    : '****';
  return (
    <>
      <div styleName="user-logout-container">
        <NavBar
          title="安全验证"
          onClickBackBtn={clickBack}
          hideBackButton={window?.__wxjs_environment === 'miniprogram'}
        />
        <div styleName="verify-container">
          <div styleName="tip">
            给手机号{renderPhone}发送验证码，进行身份验证
          </div>
          <Input
            maxLength={6}
            value={verifyCode}
            type="text"
            onClear={clearVerifyStatus}
            onChange={handleInputChange}
            onComposition={handleComposition}
            placeholder="请输入手机验证码"
          >
            <div
              styleName={`get-verify ${disable ? 'disable' : ''}`}
              onClick={handleVerify}
            >
              {content}
            </div>
          </Input>
          <div
            styleName="verify-help"
            onClick={() => controlDisplayHelpModal(true)}
          >
            获取不到验证码？
          </div>
          <div
            styleName={`btn ${verifyCode.length === 6 ? 'usual' : 'disable'}`}
            onClick={handleLogout}
          >
            确认注销
          </div>
        </div>
      </div>
      {showHelpModal && (
        <VerifyHelp onClose={() => controlDisplayHelpModal(false)} />
      )}
      <ReactGeetest
        appCode={code}
        product="bind"
        ref={geetsetRef}
        onReady={handleGeetestReady}
        onSuccess={handleGeetestSuccess}
        onError={handleGeetestError}
        onClose={handleGeetestClose}
        onFail={handleGeetestFail}
        https="true"
        width="242px"
        env={process.env.NODE_ENV === 'production' ? 'pro' : 'test'}
        loading={null}
      />
      {checkResult?.checkType === 'error' ? (
        <Error
          onClose={() => setCheckResult(null)}
          eventCodes={checkResult?.code || []}
        />
      ) : null}
      {checkResult?.checkType === 'success' ? (
        <Success onClose={() => setCheckResult(null)} />
      ) : null}
    </>
  );
};

export default forwardRef(Verify);
